import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <CommentsSection />
        <AppSection />
        <TopicsSection />
        <RankingSection />
        <FeaturesSection />
        <IndexSection />
        <AboutSection />
        <MediaSection />
        <CardsSection />
        <UpdatesSection />
        <ContactSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}